import { uniqBy } from 'lodash'
import { getActiveCalendarEnrolments, getCurrentEnrolledUnits, getStudyPeriodToSemesterNameCacheKey } from '../services/vu'
import { getCourseId } from './course'
import ProcessType from '../enums/ProcessType'
import UnitStatus from '../enums/UnitStatus'

/**
 * @return {Array<string>}
 */
export const getSupportedCalendarTypes = () =>
  [].concat(
    getStudyPeriodCalendarTypes(),
    getAllSemester1CalendarTypes(),
    getAllSemester2CalendarTypes(),
    getAllSummerCalendarTypes(),
    getAllWinterCalendarTypes(),
    getMelbourneTrimesters(),
    getSydneyTrimesters(),
    getDualInstanceBlockWeek5CalendarTypes(),
    getOffShoreCalendarTypes()
  )

export const HIGHER_EDUCATION_WINTER_BLOCK_1 = 'HWB'
export const HIGHER_EDUCATION_SUMMER_BLOCK_1 = 'HSB'
export const HIGHER_EDUCATION_SUMMER_BLOCK_2 = 'HSB2'
export const HIGHER_EDUCATION_SEMESTER_1_BLOCK_1 = 'H1B1'
export const HIGHER_EDUCATION_SEMESTER_1_BLOCK_2 = 'H1B2'
export const HIGHER_EDUCATION_SEMESTER_1_BLOCK_3 = 'H1B3'
export const HIGHER_EDUCATION_SEMESTER_1_BLOCK_4 = 'H1B4'
export const HIGHER_EDUCATION_SEMESTER_2_BLOCK_1 = 'H2B1'
export const HIGHER_EDUCATION_SEMESTER_2_BLOCK_2 = 'H2B2'
export const HIGHER_EDUCATION_SEMESTER_2_BLOCK_3 = 'H2B3'
export const HIGHER_EDUCATION_SEMESTER_2_BLOCK_4 = 'H2B4'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_1 = 'H8W1'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_2 = 'H8W2'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_3 = 'H8W3'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_4 = 'H8W4'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_5 = 'H8W5'
export const HIGHER_EDUCATION_SEMESTER_1 = 'HS1'
export const HIGHER_EDUCATION_SEMESTER_2 = 'HS2'
export const HIGHER_EDUCATION_SEMESTER_4 = 'HS4'
export const HIGHER_EDUCATION_SEMESTER_3 = 'HS3'
export const HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1 = 'HMT1'
export const HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2 = 'HMT2'
export const HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3 = 'HMT3'
export const HIGHER_EDUCATION_TRIMESTER_1 = 'HT1'
export const HIGHER_EDUCATION_TRIMESTER_2 = 'HT2'
export const HIGHER_EDUCATION_TRIMESTER_3 = 'HT3'
export const HIGHER_EDUCATION_VU_ONLINE_1 = 'HVO1'
export const HIGHER_EDUCATION_VU_ONLINE_2 = 'HVO2'
export const HIGHER_EDUCATION_VU_ONLINE_3 = 'HVO3'
export const HIGHER_EDUCATION_VU_ONLINE_4 = 'HVO4'
export const HIGHER_EDUCATION_VU_ONLINE_5 = 'HVO5'
export const HIGHER_EDUCATION_VU_ONLINE_6 = 'HVO6'
export const HIGHER_EDUCATION_OFFSHORE_1 = 'HOS1'
export const HIGHER_EDUCATION_OFFSHORE_2 = 'HOS2'
export const HIGHER_EDUCATION_OFFSHORE_3 = 'HOS3'
export const HIGHER_EDUCATION_OFFSHORE_4 = 'HOS4'

/**
 * @return {Array<string>}
 */
export const getMelbourneTrimesters = () => [HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1, HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2, HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3]

/**
 * @return {Array<string>}
 */
export const getSydneyTrimesters = () => [HIGHER_EDUCATION_TRIMESTER_1, HIGHER_EDUCATION_TRIMESTER_2, HIGHER_EDUCATION_TRIMESTER_3]

/**
 * @return {Array<string>}
 */
export const getStudyPeriodCalendarTypes = () => [
  HIGHER_EDUCATION_VU_ONLINE_1,
  HIGHER_EDUCATION_VU_ONLINE_2,
  HIGHER_EDUCATION_VU_ONLINE_3,
  HIGHER_EDUCATION_VU_ONLINE_4,
  HIGHER_EDUCATION_VU_ONLINE_5,
  HIGHER_EDUCATION_VU_ONLINE_6
]

/**
 * @return {Array<string>}
 */
export const getAllSemester1CalendarTypes = () => getSemester1CalendarTypes().concat(getSemester1BlockModelCalendarTypes(), getSemester1DualInstanceBlockModelCalendarTypes())

/**
 * @return {Array<string>}
 */
export const getSemester1CalendarTypes = () => [HIGHER_EDUCATION_SEMESTER_1]

/**
 * @return {Array<string>}
 */
export const getOffShoreCalendarTypes = () => [HIGHER_EDUCATION_OFFSHORE_1, HIGHER_EDUCATION_OFFSHORE_2, HIGHER_EDUCATION_OFFSHORE_3, HIGHER_EDUCATION_OFFSHORE_4]

/**
 * @return {Array<string>}
 */
export const getSemester1BlockModelCalendarTypes = () => [
  HIGHER_EDUCATION_SEMESTER_1_BLOCK_1,
  HIGHER_EDUCATION_SEMESTER_1_BLOCK_2,
  HIGHER_EDUCATION_SEMESTER_1_BLOCK_3,
  HIGHER_EDUCATION_SEMESTER_1_BLOCK_4
]

/**
 * @return {Array}
 */
export const getSemester1DualInstanceBlockModelCalendarTypes = () => [HIGHER_EDUCATION_8_WEEK_BLOCK_1, HIGHER_EDUCATION_8_WEEK_BLOCK_2]

/**
 * @return {Array<string>}ic
 */
export const getAllSemester2CalendarTypes = () => getSemester2CalendarTypes().concat(getSemester2BlockModelCalendarTypes(), getSemester2DualInstanceBlockModelCalendarTypes())

/**
 * @return {Array<string>}
 */
export const getSemester2CalendarTypes = () => [HIGHER_EDUCATION_SEMESTER_2]

/**
 * @return {Array<string>}
 */
export const getSemester2BlockModelCalendarTypes = () => [
  HIGHER_EDUCATION_SEMESTER_2_BLOCK_1,
  HIGHER_EDUCATION_SEMESTER_2_BLOCK_2,
  HIGHER_EDUCATION_SEMESTER_2_BLOCK_3,
  HIGHER_EDUCATION_SEMESTER_2_BLOCK_4
]

/**
 * @return {Array}
 */
export const getSemester2DualInstanceBlockModelCalendarTypes = () => [HIGHER_EDUCATION_8_WEEK_BLOCK_3, HIGHER_EDUCATION_8_WEEK_BLOCK_4]

/**
 * @return {Array<string>}
 */
export const getAllSummerCalendarTypes = () => getSummerCalendarTypes().concat(getSummerBlockModelOpeningCalendarTypes(), getSummerBlockModelClosingCalendarTypes())

/**
 * @return {Array<string>}
 */
export const getSummerCalendarTypes = () => [HIGHER_EDUCATION_SEMESTER_3]

/**
 * @return {Array<string>}
 */
export const getSummerBlockModelCalendarTypes = () => [].concat(getSummerBlockModelOpeningCalendarTypes(), getSummerBlockModelClosingCalendarTypes())

/**
 * @return {Array<string>}
 */
export const getSummerBlockModelOpeningCalendarTypes = () => [HIGHER_EDUCATION_SUMMER_BLOCK_1]

/**
 * @return {Array<string>}
 */
export const getSummerBlockModelClosingCalendarTypes = () => [HIGHER_EDUCATION_SUMMER_BLOCK_2]

/**
 * @return {Array}
 */
export const getDualInstanceBlockWeek5CalendarTypes = () => [HIGHER_EDUCATION_8_WEEK_BLOCK_5]

/**
 * @return {Array<string>}
 */
export const getAllWinterCalendarTypes = () => getWinterCalendarTypes().concat(getWinterBlockModelCalendarTypes())

/**
 * @return {Array<string>}
 */
export const getWinterCalendarTypes = () => [HIGHER_EDUCATION_SEMESTER_4]

/**
 * @return {Array<string>}
 */
export const getWinterBlockModelCalendarTypes = () => [HIGHER_EDUCATION_WINTER_BLOCK_1]

/**
 * @return {Array<string>}
 */
export const getBlockModelCalendarTypes = () =>
  [].concat(
    getSemester1BlockModelCalendarTypes(),
    getSemester2BlockModelCalendarTypes(),
    getWinterBlockModelCalendarTypes(),
    getSummerBlockModelOpeningCalendarTypes(),
    getSummerBlockModelClosingCalendarTypes()
  )

/**
 * @return {Array<string>}
 */
export const getDualInsanceBlockModelCalendarTypes = () =>
  [].concat(getSemester1DualInstanceBlockModelCalendarTypes(), getSemester2DualInstanceBlockModelCalendarTypes(), getDualInstanceBlockWeek5CalendarTypes())

export const getCurrentYear = () => new Date().getFullYear()

/**
 * @param {string} calendarType
 * @returns {string}
 */
export const getBlockTitle = calendarType => {
  switch (calendarType) {
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_1:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_1:
    case HIGHER_EDUCATION_SUMMER_BLOCK_1:
    case HIGHER_EDUCATION_WINTER_BLOCK_1:
      return 'Block 1'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_1:
      return '8 Week - Block 1'
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_2:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_2:
      return 'Block 2'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_2:
      return '8 Week - Block 2'
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_3:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_3:
      return 'Block 3'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_3:
      return '8 Week - Block 3'
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_4:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_4:
      return 'Block 4'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_4:
      return '8 Week - Block 4'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_5:
      return ''
    default:
      return ''
  }
}

/**
 * @param {string} period
 * @returns {string}
 */
export const getPeriodNames = studyPeriodCode => {
  let studyPeriodToSemesterNames = JSON.parse(sessionStorage.getItem(getStudyPeriodToSemesterNameCacheKey))
  let semesterNames = studyPeriodToSemesterNames
    ? studyPeriodToSemesterNames
        .filter(studyPeriodToSemesterName => studyPeriodToSemesterName.studyPeriodCode === studyPeriodCode)
        .map(studyPeriodToSemesterName => studyPeriodToSemesterName.semesterName)
    : null

  return semesterNames !== null && semesterNames !== undefined && semesterNames.length > 0 ? semesterNames[0] : studyPeriodCode
}

export const getNextBlock = currentBlock => {
  let blocks = [
    //Summer (Jan)
    HIGHER_EDUCATION_SUMMER_BLOCK_1,
    //Semester1
    HIGHER_EDUCATION_SEMESTER_1_BLOCK_1,
    HIGHER_EDUCATION_SEMESTER_1_BLOCK_2,
    HIGHER_EDUCATION_SEMESTER_1_BLOCK_3,
    HIGHER_EDUCATION_SEMESTER_1_BLOCK_4,
    //Winter
    HIGHER_EDUCATION_WINTER_BLOCK_1,
    //Semester2
    HIGHER_EDUCATION_SEMESTER_2_BLOCK_1,
    HIGHER_EDUCATION_SEMESTER_2_BLOCK_2,
    HIGHER_EDUCATION_SEMESTER_2_BLOCK_3,
    HIGHER_EDUCATION_SEMESTER_2_BLOCK_4
    //Summer (Dec) - Removing summer block as this is discontinued
    //HIGHER_EDUCATION_SUMMER_BLOCK_2
  ]

  let index = blocks.indexOf(currentBlock)

  if (index == -1) {
    //current block not found
    return null
  }

  if (index == blocks.length - 1) {
    //last unit of the year!
    return null
  }

  return blocks[index + 1]
}

export const getCalendarTypeName = (studyPeriodCode, studyPeriods) => {
  const studyPeriodDescription = studyPeriods.filter(studyPeriod => studyPeriod.code === studyPeriodCode)[0]

  return studyPeriodDescription ? studyPeriodDescription.description.replace("HE", "").trim() : ""
}

export const getYearsEnrolled = () => {
  let enrollableYears = getAttributeCourseStaticInfo('enrolmentYearsAsString')
    ? getAttributeCourseStaticInfo('enrolmentYearsAsString')
        .replace(/\s+/g, '')
        .split(',')
    : [parseInt(getAttributeCourseStaticInfo('availabilityYear')) > new Date().getFullYear() ? getAttributeCourseStaticInfo('availabilityYear') : new Date().getFullYear()]

  return enrollableYears.sort((a, b) => {
    if (a > b) {
      return -1
    }

    if (a < b) {
      return 1
    }

    return 0
  })
}

export const sortYearAsc = (a, b) => {
  if (a > b) {
    return 1
  }

  if (a < b) {
    return -1
  }

  return 0
}

export const readonly = unit => unit.unitStatus === 'PASS' || unit.unitStatus === 'FAIL'

export const isPlanUnit = unit => unit.unitStatus === 'PLN'

export const getUnitsByYear = (units, year) => units.filter(unit => unit.unitAvailabilityYear === year)

export const getUnitsByCalendarTypes = (units, calendarTypes = [], year) => getUnitsByYear(units, year).filter(unit => calendarTypes.indexOf(unit.unitAvailabilityStudyPeriodCode) > -1)

export const getCohortByCalendarTypeAndProcessType = (cohorts, processType, calendarType, year) => {
  return cohorts.find(({ cohortDtls }) => {
    return cohortDtls.calType === calendarType && cohortDtls.sProcessType === processType && cohortDtls.acadAlternateCode === year
  })
}

export const getAddCohortByCalendarType = (cohorts, calendarType, year) => {
  return getCohortByCalendarTypeAndProcessType(cohorts, ProcessType.AddUnit, calendarType, year)
}

export const getDropCohortByCalendarType = (cohorts, calendarType, year) => {
  return getCohortByCalendarTypeAndProcessType(cohorts, ProcessType.DropUnit, calendarType, year)
}

/**
 * Get all the active enrolled units that are part of the block model calendar
 * type, e.g. SEM-1-B1.
 *
 * @param {Array} units
 * @return {Array}
 */
export const getActiveEnrolledSingleInstanceCalendarTypeUnits = units => {
  const singleInstanceCalendarTypes = getBlockModelCalendarTypes().concat(getStudyPeriodCalendarTypes())

  return units.filter(unit => singleInstanceCalendarTypes.indexOf(unit.unitAvailabilityStudyPeriodCode) > -1)
}

/**
 * Get all the active enrolled units that are part of the block model calendar
 * type, e.g. SEM-8W-B1.
 *
 * @param {Array} units
 * @return {Array}
 */
export const getActiveEnrolledDualInstanceCalendarTypeUnits = units => {
  const dualInstanceCalendarTypes = getDualInsanceBlockModelCalendarTypes()

  return units.filter(unit => dualInstanceCalendarTypes.indexOf(unit.unitAvailabilityStudyPeriodCode) > -1)
}

/**
 * Checks if a student already enrolled into a number of unit instances for the requested block
 * model calendar type, e.g. SEM-1-B1, and year only 1 and SEM-8W-B1 and year only 2.
 *
 * @param {Array} units
 * @param {string} calendarType
 * @param {string} year
 * @param {int} numberOfInstancesMaximum - Maximum instances a block can hold
 * @return {boolean}
 */
export const willDoubleUpUnits = (units, calendarType, year, numberOfInstancesMaximum = 1) => {
  let activeEnrolledUnitInstances = numberOfInstancesMaximum === 1 ? getActiveEnrolledSingleInstanceCalendarTypeUnits(units) : getActiveEnrolledDualInstanceCalendarTypeUnits(units)

  return (
    activeEnrolledUnitInstances.filter(unit => {
      return unit.unitAvailabilityStudyPeriodCode === calendarType && unit.unitAvailabilityYear === year
    }).length >= numberOfInstancesMaximum
  )
}

/**
 * Checks if the student is enrolled in the unit this year.
 *
 * @param {Array} units
 * @param {string} calendarType
 * @param {string} year
 * @param {int} numberOfInstancesMaximum - Maximum instances a block can hold
 * @return {boolean}
 */
export const alreadyEnrolledUnit = (units, selectedUnit) => {
  return (
    units.filter(unit => {
      return unit.unitCode === selectedUnit.unitCode && unit.unitAvailabilityYear === selectedUnit.unitAvailabilityYear
    }).length > 0
  )
}

export const isUpdatingUnitLocation = (oldUnit, updatedUnit) =>
  oldUnit.supAlternateCd === updatedUnit.supAlternateCd && oldUnit.calendarType === updatedUnit.calendarType && oldUnit.locationCd !== updatedUnit.locationCd

export const getActiveAddCalendars = (cohortCd = [], commencementDate) => {
  return getActiveCalendarEnrolments(cohortCd, [ProcessType.AddUnit], commencementDate)
}

export const getActiveEnrollableCalendars = (cohortCd = [], commencementDate) => {
  return getActiveCalendarEnrolments(cohortCd, [ProcessType.AddUnit, ProcessType.DropUnit], commencementDate)
}
//Adding unitClass as part of DSES-86
export const mapSearchResultToEnrolmentUnit = ({ ciSequenceNo, calType, locationCd, unitCode, unitClass, unitUniqueIdentifier, supAlternateCd }) => {
  return {
    calendarSequenceNumber: ciSequenceNo,
    calendarType: calType,
    locationCd: locationCd,
    unitCd: unitCode,
    unitClass: unitClass,
    unitUniqueIdentifier: unitUniqueIdentifier,
    supAlternateCd: supAlternateCd,
    prerequnitlist: {}
  }
}

export const getEnrolledUnits = (parentSSPNo, patternId, patternStatus) => {
  return getCurrentEnrolledUnits(parentSSPNo, patternId, patternStatus)
}

/**
 * @returns {string[]}
 */
export const getCohortCodes = () => {
  const cohortCds = sessionStorage.getItem('COHORT_STATUS')
  if (cohortCds) {
    return JSON.parse(cohortCds)
  }
  return []
}

export const getEmptyCoursePatterns = () => ({
  personId: '',
  courseCd: '',
  core: [],
  pattern: { core: [] },
  bau: { core: [] },
  nonCore: []
})

/*
  Returns array containing the unit and any 'virtual units'
  - Virtual units are placeholder units used to represent units with CP>12
  eg1. A unit with a CP of 24 => [Unit, VirtualUnit]
  eg2. A unit with CP of 36 => [Unit, VirtualUnit, VirtualUnit]
*/
export const getVirtualUnits = unit => {
  let calendarTypes = calculateCalendarTypesForCreditPoints(unit.unitAvailabilityStudyPeriodCode, unit.unitCreditPoints)
  return calendarTypes.map(calType => {
    const unitClone = { ...unit }
    unitClone.unitAvailabilityStudyPeriodCode = calType
    unitClone.virtual = true
    return unitClone
  })
}

export const calculateCalendarTypesForCreditPoints = (startCalendarType, creditPoints) => {
  let calendarPeriodCount = creditPoints / 12
  let currentCalendarType = startCalendarType
  return new Array(calendarPeriodCount)
    .fill(null)
    .map(() => {
      if (currentCalendarType !== null) {
        let calType = currentCalendarType
        currentCalendarType = getNextBlock(currentCalendarType)

        if (currentCalendarType != null) {
          return calType
        }
      }
      return null
    })
    .filter(item => item !== null)
}

export const addVirtualUnits = units => {
  let virtualUnitSet = units
  units.forEach(unit => {
    let virtualUnits = getVirtualUnits(unit)
    virtualUnitSet.push(...virtualUnits)
  })
  return virtualUnitSet
}

export const removeVirtualUnitsOverlappingRealUnits = enrolledUnits => {
  return enrolledUnits.filter(enrolledUnit => {
    if (enrolledUnit.virtual !== true) {
      return true
    }

    let virtualUnitOverlapsRealUnit =
      enrolledUnits.filter(
        aUnit =>
          aUnit.virtual !== true &&
          (aUnit.unitStatus === UnitStatus.PLANNED || aUnit.unitStatus === UnitStatus.ENROLLED || aUnit.unitStatus === UnitStatus.PASS || aUnit.unitStatus === UnitStatus.FAIL) &&
          aUnit.unitAvailabilityStudyPeriodCode == enrolledUnit.unitAvailabilityStudyPeriodCode
      ).length > 0

    return !virtualUnitOverlapsRealUnit
  })
}

/**
 * Checks whether the calendar types for a given unit will overlap the calendar types of other units in an array
 */
export const willOverlapUnits = (givenUnit, enrolledUnits) => {
  const year = givenUnit.supAlternateCd

  //Get calendars types associated with givenUnit (taking into account CP)
  const givenUnitCalendarTypes = calculateCalendarTypesForCreditPoints(givenUnit.unitAvailabilityStudyPeriodCode, givenUnit.unitCreditPoints)

  return enrolledUnits
    .filter(enrolledUnit => enrolledUnit.unitAvailabilityYear === year)
    .some(enrolledUnit => {
      //Get calendar types associated with other units (taking into account CP)
      let unitCalendarTypes = calculateCalendarTypesForCreditPoints(enrolledUnit.unitAvailabilityStudyPeriodCode, enrolledUnit.unitCreditPoints)

      //Check whether calendar types of unit overlap with given unit
      return unitCalendarTypes.some(calType => givenUnitCalendarTypes.includes(calType))
    })
}

export const willExceed48CreditPoints = (enrolledUnits, givenUnit) => {
  let currentCreditPoints = enrolledUnits
    .filter(enrolledUnit => enrolledUnit.unitAvailabilityYear === givenUnit.unitAvailabilityYear && enrolledUnit.unitAvailabilityStudyPeriodCode === givenUnit.unitAvailabilityStudyPeriodCode)
    .map(enrolledUnits => enrolledUnits.unitCreditPoints)
    .reduce((a,b) => a+b, 0)

  return currentCreditPoints + givenUnit.unitCreditPoints > 48
}

/**
 * Uses the unit and cohorts to determine whether the unit will fit into the calendar periods for a set of cohorts
 */
export const willUnitFitIntoCalendar = (unit, cohorts) => {
  const year = unit.unitAvailabilityYear

  const validCalendarTypes = cohorts.filter(cohort => cohort.cohortDtls.acadAlternateCode === year).map(cohort => cohort.cohortDtls.calType)

  const unitCalendarTypes = calculateCalendarTypesForCreditPoints(unit.unitAvailabilityStudyPeriodCode, unit.unitCreditPoints)

  //Check calendar types associated with the unit fit into valid calendar types for this student
  return unitCalendarTypes.every(c1 => validCalendarTypes.some(c2 => c2 === c1))
}

export const hasCoursePatterns = hasCoursePatternsFlag => {
  switch (hasCoursePatternsFlag) {
    case 'Y':
      //New course pattern for shuffle, indicates course patterns exist
      return true
    case 'P':
      //Old course pattern flag (pre-shuffle), indicates course patterns exist
      return true
    default:
      //N (or null), indicates course patterns do not exist
      return false
  }
}

/*
  Iterates through the enrolled Units of a student to determine whether they are enrolling for the first time
*/
export const enrollingForFirstTime = units => {
  if (units == null || units.length === 0) {
    // If unitset is empty (no enrolled units) then assume the student is enrolling for the first time
    return true
  }
  //If all units that the student is currently enrolled in are unconfirmed then assume the student is enrolling for the first time
  return units.every(unit => unit.attemptStatus === 'UNCONFIRM' || (unit.attemptStatus === null && unit.patternstatus === 'ERROR'))
}
//moving this pre-req check to common place
export const hasPrereqErrors = (isRemoved, unit, enrolledUnits) => {
  if (isRemoved) {
    /*
	        Removing a unit - Do not allow it to be removed if it is a prerequisite of another active units
	      */
    let prereqUnits = enrolledUnits
      .filter(enrolledUnit => enrolledUnit.removed !== true)
      .filter(enrolledUnit => enrolledUnit.virtual !== true)
      .filter(enrolledUnit => enrolledUnit.attemptStatus !== 'DISCONTIN')
      .filter(enrolledUnit => enrolledUnit.prerequnitlist != null)
      .filter(enrolledUnit => enrolledUnit.prerequnitlist.prerequnits != null)
      .filter(enrolledUnit => enrolledUnit.prerequnitlist.prerequnits.map(prerequnit => prerequnit.prerequnitcd).includes(unit.unitCd))
      .map(enrolledUnit => enrolledUnit.unitCd)

    if (prereqUnits.length > 0) {
      var prereqCd = ''
      for (const [index, value] of prereqUnits.entries()) {
        index === 1 ? (prereqCd = value) : (prereqCd = prereqCd + ' and ' + value)
      }
      alert(unit.unitCd + ' is a prerequisite for ' + prereqCd + '. Before you can remove this unit you must un-enrol from ' + prereqCd + '. This may impact your course progression.')
      return true
    }
  } else {
    /*
	        Re-adding the unit - Do not allow it to be re-added if one of it's prerequisites is inactive
	      */
    if (unit.prerequnitlist != null && unit.prerequnitlist.prerequnits != null) {
      let requiredUnitCds = unit.prerequnitlist.prerequnits.map(prerequnit => prerequnit.prerequnitcd)

      let prereqUnits = enrolledUnits
        .filter(enrolledUnit => enrolledUnit.removed === true)
        .filter(enrolledUnit => enrolledUnit.virtual !== true)
        .filter(enrolledUnit => requiredUnitCds.includes(enrolledUnit.unitCd))
        .map(enrolledUnit => enrolledUnit.unitCd)

      if (prereqUnits.length > 0) {
        var prereqCd = ''
        for (const [index, value] of prereqUnits.entries()) {
          index === 1 ? (prereqCd = value) : (prereqCd = prereqCd + ' and ' + value)
        }
        alert(prereqUnits + ' is a prerequisite of unit ' + unit.unitCd + ', please enable it first')
        return true
      }
    }
  }

  return false
}

export const getOpenCalendarYears = cohorts => {
  let openCohortYears = cohorts
    .filter(({ cohortDtls }) => {
      return cohortDtls.sProcessType === 'ADD-UNIT'
    })
    .map(({ cohortDtls }) => {
      return cohortDtls.acadAlternateCode
    })
    .sort(sortYearAsc)

  return Array.from(new Set(openCohortYears))
}

export const loadedCourseInformation = () => {
  const courseId = getCourseId()
  const cacheName = `COURSE_STATIC_INFO_${courseId}`
  return sessionStorage.getItem(cacheName) !== null
}

export const courseStaticInfoCache = (offer, courseId, convertBoolean = true) => {
  const cacheName = `COURSE_STATIC_INFO_${courseId}`
  let offerToCache = {}
  if (convertBoolean) {
    Object.keys(offer).forEach(key => {
      offerToCache[key] = typeof offer[key] == 'boolean' ? (offer[key] ? 'Y' : 'N') : offer[key]
    })
  } else {
    offerToCache = offer
  }

  sessionStorage.setItem(cacheName, JSON.stringify(offerToCache))
}

export const getCourseStaticInfoCache = () => {
  const courseId = getCourseId()
  const cacheName = `COURSE_STATIC_INFO_${courseId}`
  const courseStaticInfoFromCache = sessionStorage.getItem(cacheName)
  return JSON.parse(courseStaticInfoFromCache)
}

export const getAttributeCourseStaticInfo = attributeName => {
  const courseId = getCourseId()
  const cacheName = `COURSE_STATIC_INFO_${courseId}`

  const courseStaticInfoFromCache = sessionStorage.getItem(cacheName)

  if (courseStaticInfoFromCache != null) {
    const attributeValue = JSON.parse(courseStaticInfoFromCache)[attributeName]
    return attributeValue
  } else {
    return null
  }
}

export const hasDuplicates = (array, maxInstances = 1) => {
  let countedInstances = {}
  let i = 0
  for (i = 0; i < array.length; i++) {
    const value = array[i]
    countedInstances[value] = countedInstances[value] ? countedInstances[value] + 1 : 1

    if (countedInstances[value] > maxInstances) {
      return true
    }
  }
  return false
}

export const unitInstanceCount = array => {
  let countedInstances = {}
  let i = 0
  for (i = 0; i < array.length; i++) {
    const value = array[i]
    countedInstances[value] = countedInstances[value] ? countedInstances[value] + 1 : 1
  }
  return countedInstances
}

export const getCourseStudentStudyPackageNumber = () => {
  return getAttributeCourseStaticInfo('courseSSPNo')
}

export const isStudentOnLeave = () => {
  return getAttributeCourseStaticInfo('courseStatus') === 'AWOL'
}

export const getFlattenedUnitsWithMultipleAttendanceModes = units => {
  return uniqBy(units, function(elem) {
    return [elem.unitCode, elem.unitAvailabilityLocationCode, elem.unitAvailabilityYear, elem.unitAvailabilityStudyPeriodCode].join()
  })
}

export const isChooseDeliveryToBeEnabled = (unit, enrolledUnits) => {
  const unitInstances = enrolledUnits.filter(enrolledUnit => {
    return (
      enrolledUnit.virtual !== true &&
      enrolledUnit.unitAvailabilityStudyPeriodCode === unit.unitAvailabilityStudyPeriodCode &&
      enrolledUnit.unitAvailabilityYear === unit.unitAvailabilityYear &&
      enrolledUnit.unitCode === unit.unitCode &&
      enrolledUnit.unitAvailabilityLocationCode === unit.unitAvailabilityLocationCode
    )
  }).length

  return unitInstances > 1
}

export const getUnitsWithMultipleAttendanceModes = enrolledUnits => {
  let enrolledUnitsWithAttendanceModes = enrolledUnits.filter(unit => unit.unitStatus === UnitStatus.PLANNED && unit.virtual !== true && isChooseDeliveryToBeEnabled(unit, enrolledUnits))
  return uniqBy(enrolledUnitsWithAttendanceModes, 'unitCode').map(unit => unit.unitCode)
}

export const hasSanctions = (personalDetails, courseId) => {
  let sanctions =
    personalDetails.studentSanctions === null || personalDetails.studentSanctions.length === 0
      ? []
      : personalDetails.studentSanctions.filter(
          sanction =>
            (sanction.holdCd === '$PE' || sanction.holdCd === '$PSPA') &&
            (!sanction.studyPackageCode || sanction.studyPackageCode === courseId) &&
            sanction.expiryDateValid &&
            sanction.effectiveDateValid
        )

  if (sanctions.length > 0) {
    return true
  } else {
    return false
  }
}

export const getEnrolSanctionsType = (sanctions, courseId) => {
  if (!Array.isArray(sanctions) || sanctions.length === 0 || !courseId) {
    return []
  }

  const enrolSanctions = sanctions.filter(
    sanction =>
      (sanction.holdCd === '$PE' || sanction.holdCd === '$PSPA') &&
      (!sanction.studyPackageCode || sanction.studyPackageCode === courseId) &&
      sanction.expiryDateValid &&
      sanction.effectiveDateValid
  )

  const sanctionTypes = Array.from(new Set(enrolSanctions.map(s => s.sanctionType)))

  return sanctionTypes
}